// import React, { useEffect, useState } from "react";
// import Navbar from "../common/Navbar";
// import Footer from "../common/Footer";
// import Sidebar from "../common/Sidebar";
// import MessageModal from "./MessageModal";
// import { FiMail, FiChevronRight, FiPaperclip, FiClock } from "react-icons/fi";
// import "./MyMessages.css";

// const BASE_URL = process.env.REACT_APP_BASE_URL;

// const MyMessages = () => {
//   const [messages, setMessages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [selectedMessage, setSelectedMessage] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   useEffect(() => {
//     const fetchMessages = async () => {
//       setLoading(true);
//       setError(null);

//       try {
//         const token = sessionStorage.getItem("token");

//         const response = await fetch(
//           `${BASE_URL}/api/mailmessage/getallloginedConversation`,
//           {
//             method: "GET",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         if (!response.ok) {
//           const errorData = await response.json();
//           throw new Error(errorData.message || "Failed to fetch messages");
//         }

//         const data = await response.json();

//         // Sort messages by most recent first
//         const sortedMessages = data.messages.sort(
//           (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
//         );
//         setMessages(sortedMessages);
//       } catch (error) {
//         console.error("Error fetching messages:", error);
//         setError(error.message || "Something went wrong");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchMessages();
//   }, []);

//   const handleReadMore = async (message) => {
//     // If the message has not been read, update the status to read
//     if (!message.read) {
//       try {
//         const token = sessionStorage.getItem("token");
//         const response = await fetch(
//           `${BASE_URL}/api/mailmessage/updateReadStatus/${message._id}`,
//           {
//             method: "PATCH",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         if (!response.ok) {
//           const errorData = await response.json();
//           throw new Error(errorData.message || "Failed to update read status");
//         }

//         // Update the local state to reflect the message is read
//         setMessages((prevMessages) =>
//           prevMessages.map((msg) =>
//             msg._id === message._id ? { ...msg, read: true } : msg
//           )
//         );
//       } catch (error) {
//         console.error("Error updating message read status:", error);
//         setError(error.message || "Failed to update message status");
//       }
//     }

//     // Open the modal with the selected message
//     setSelectedMessage(message);
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedMessage(null);
//   };

//   if (loading) {
//     return (
//       <div className="messages-loading-container">
//         <div className="messages-loading-spinner"></div>
//         <p>Loading your messages...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="messages-error-container">
//         <div className="messages-error-icon">!</div>
//         <h3>Error Loading Messages</h3>
//         <p>{error}</p>
//         <button
//           className="messages-retry-button"
//           onClick={() => window.location.reload()}
//         >
//           Try Again
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div className="messages-page-container">
//       <Navbar />
//       <Sidebar />

//       <main className="messages-main-content">
//         <div className="messages-header">
//           <h1 className="messages-title">
//             <FiMail className="messages-title-icon" />
//             My Inbox
//           </h1>
//           <div className="messages-count-badge">
//             {messages.length} {messages.length === 1 ? "Message" : "Messages"}
//           </div>
//         </div>

//         {messages.length === 0 ? (
//           <div className="messages-empty-state">
//             <FiMail className="messages-empty-icon" />
//             <h3>No Messages Found</h3>
//             <p>
//               Your inbox is currently empty. When you receive messages, they'll
//               appear here.
//             </p>
//           </div>
//         ) : (
//           <div className="messages-list-container">
//             {messages.map((message) => (
//               <div
//                 key={message._id}
//                 className={`message-card ${
//                   message.read ? "message-read" : "message-unread"
//                 }`}
//                 onClick={() => handleReadMore(message)}
//               >
//                 <div className="message-card-header">
//                   <div className="message-sender">
//                     {message.sender}
//                     <span className="message-to">to {message.receiver}</span>
//                   </div>
//                   <div className="message-time">
//                     <FiClock className="message-time-icon" />
//                     {new Date(message.createdAt).toLocaleString("en-US", {
//                       month: "short",
//                       day: "numeric",
//                       hour: "2-digit",
//                       minute: "2-digit",
//                     })}
//                   </div>
//                 </div>

//                 <h3 className="message-subject">{message.subject}</h3>

//                 <p className="message-preview">
//                   {message.message.length > 100
//                     ? `${message.message.substring(0, 100)}...`
//                     : message.message}
//                 </p>

//                 {message.files && message.files.length > 0 && (
//                   <div className="message-attachments">
//                     <FiPaperclip className="attachment-icon" />
//                     <span className="attachment-count">
//                       {message.files.length}{" "}
//                       {message.files.length === 1
//                         ? "attachment"
//                         : "attachments"}
//                     </span>
//                   </div>
//                 )}

//                 <div className="message-read-more">
//                   <span>View Details</span>
//                   <FiChevronRight className="read-more-icon" />
//                 </div>

//                 {!message.read && <div className="message-unread-badge"></div>}
//               </div>
//             ))}
//           </div>
//         )}
//       </main>

//       <MessageModal
//         isOpen={isModalOpen}
//         onClose={handleCloseModal}
//         message={selectedMessage}
//       />

//       <Footer />
//     </div>
//   );
// };

// export default MyMessages;































import React, { useEffect, useState } from "react";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import Sidebar from "../common/Sidebar";
import MessageModal from "./MessageModal";
import { FiMail, FiChevronRight, FiPaperclip, FiClock } from "react-icons/fi";
import "./MyMessages.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { FiClock } from "react-icons/fi";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import {
  faClock,
  faUser,
  faEnvelope,
  faCalendarAlt,
  faTasks,
  faSearch,
  faSyncAlt,
  faExclamationCircle,
  faChevronLeft,
  faFilter,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

import { Box, Typography, Paper, IconButton, Alert, CircularProgress, Card, Grid, } from "@mui/material";
import { FiX, FiCheckCircle } from "react-icons/fi";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";


const BASE_URL = process.env.REACT_APP_BASE_URL;
const MyMessages = () => {
  // ...your state and logic...
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const fetchMessages = async () => {
      setLoading(true);
      setError(null);

      try {
        const token = sessionStorage.getItem("token");

        const response = await fetch(
          `${BASE_URL}/api/mailmessage/getallloginedConversation`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || "Failed to fetch messages");
        }

        const data = await response.json();

        // Sort messages by most recent first
        const sortedMessages = data.messages.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setMessages(sortedMessages);
      } catch (error) {
        console.error("Error fetching messages:", error);
        setError(error.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, []);

  const handleReadMore = async (message) => {
    // If the message has not been read, update the status to read
    if (!message.read) {
      try {
        const token = sessionStorage.getItem("token");
        const response = await fetch(
          `${BASE_URL}/api/mailmessage/updateReadStatus/${message._id}`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || "Failed to update read status");
        }

        // Update the local state to reflect the message is read
        setMessages((prevMessages) =>
          prevMessages.map((msg) =>
            msg._id === message._id ? { ...msg, read: true } : msg
          )
        );
      } catch (error) {
        console.error("Error updating message read status:", error);
        setError(error.message || "Failed to update message status");
      }
    }

    // Open the modal with the selected message
    setSelectedMessage(message);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedMessage(null);
  };

  if (loading) {
    return (
      <div className="messages-loading-container">
        <div className="messages-loading-spinner"></div>
        <p>Loading your messages...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="messages-error-container">
        <div className="messages-error-icon">!</div>
        <h3>Error Loading Messages</h3>
        <p>{error}</p>
        <button
          className="messages-retry-button"
          onClick={() => window.location.reload()}
        >
          Try Again
        </button>
      </div>
    );
  }
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        bgcolor: "#F8FAFC",
      }}
    >
      <Navbar />
      <Sidebar />

      <Box
        component="main"
        sx={{
          flex: 1,
          mt: 6,
          p: { xs: 2, md: 3 },
          ml: { md: "250px" },
          transition: "margin 0.3s ease",
          // Responsive margin and padding

        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: { xs: "stretch", sm: "center" }, // stretch on mobile, center on desktop
            mb: 3,
            flexDirection: { xs: "column", sm: "row" }, // column on mobile, row on desktop
            gap: { xs: 2, sm: 0 }, // space between title and card on mobile
          }}
        >
          {/* Left Section */}
          <Box>
            <Typography variant="h4" fontWeight="bold" gutterBottom sx={{ mb: 0 }}>
              Inbox
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              Stay on top of your latest conversations and messages
            </Typography>
          </Box>

          {/* Right Section */}
          <Grid item xs={12} sm={6} md={3}>
            <Card
              sx={{
                borderRadius: 2,
                p: 1.5,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                bgcolor: "white",
                width: { xs: "100%", sm: "auto" }, // full width on mobile
              }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                <Typography
                  sx={{
                    fontSize: 12,
                    fontWeight: 500,
                    color: "#6b7280",
                    lineHeight: 1.2,
                  }}
                >
                  Inbox Messages
                </Typography>
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: "bold",
                    color: "#000",
                    lineHeight: 1.3,
                  }}
                >
                  {messages.length} {messages.length === 1 ? "Message" : "Messages"}
                </Typography>
              </Box>

              <Box
                sx={{
                  backgroundColor: "#e0edff",
                  borderRadius: 2,
                  p: 0.8,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  ml: 1.5,
                }}
              >
                <MailOutlineIcon sx={{ color: "#2563eb", fontSize: 18 }} />
              </Box>
            </Card>

            
          </Grid>
        </Box>


        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 3,
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "flex-start", md: "center" },
          }}
        >



        </Box>

        {loading && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "60vh",

            }}
          >
            <Box
              sx={{
                border: "4px solid rgba(0, 0, 0, 0.1)",
                borderRadius: "50%",
                borderTop: "4px solid #5C85FF",
                width: 40,
                height: 40,
                mt: 60,
                animation: "spin 1s linear infinite",
                mb: 2,
                "@keyframes spin": {
                  "0%": { transform: "rotate(0deg)" },
                  "100%": { transform: "rotate(360deg)" },
                },
              }}
            />
            <Typography>Loading your messages...</Typography>
          </Box>
        )}

        {error && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "60vh",
              textAlign: "center",
              p: 3,
            }}
          >
            <Box
              sx={{
                bgcolor: "#DC2626",
                color: "white",
                width: 50,
                height: 50,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.8rem",
                fontWeight: "bold",
                mb: 2,
              }}
            >
              !
            </Box>
            <Typography variant="h5" gutterBottom>
              Error Loading Messages
            </Typography>
            <Typography>{error}</Typography>
            <Box
              component="button"
              onClick={() => window.location.reload()}
              sx={{
                bgcolor: "#5C85FF",
                color: "white",
                border: "none",
                px: 2,
                py: 1,
                borderRadius: 1,
                cursor: "pointer",
                mt: 2,
                fontSize: "1rem",
                transition: "background-color 0.3s",
                "&:hover": { bgcolor: "#1E40AF" },
              }}
            >
              Try Again
            </Box>
          </Box>
        )}

        {!loading && !error && messages.length === 0 && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "50vh",
              textAlign: "center",
              color: "#64748B",
            }}
          >
            <FiMail style={{ fontSize: 48, color: "#bdc3c7", marginBottom: 16 }} />
            <Typography variant="h6" sx={{ color: "#1E293B", mb: 1 }}>
              No Messages Found
            </Typography>
            <Typography>
              Your inbox is currently empty. When you receive messages, they'll appear here.
            </Typography>
          </Box>
        )}

        {/* Messages list */}
        <Box
          sx={{
            display: "grid",
            width: "100%",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(auto-fit, minmax(280px, 1fr))", // flexible like in screenshot
            },
            gap: "20px", // consistent spacing between cards (both directions)
            mb: 30,
          }}
        >
          {messages.map((message) => (
            /////////// old card 
            // <Box
            //   key={message._id}
            //   onClick={() => handleReadMore(message)}
            //   sx={{
            //     // bgcolor: "white",
            //     // borderRadius: 2,
            //     p: { xs: 1.5, md: 2 },
            //     // boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
            //     cursor: "pointer",
            //     position: "relative",
            //     overflow: "hidden",
            //     transition: "transform 0.2s, box-shadow 0.2s",
            //     "&:hover": {
            //       transform: "translateY(-1.5px)",
            //       boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            //     },
            //     borderLeft: message.read ? "none" : "4px solid #3498db",
            //     opacity: message.read ? 0.85 : 1,

            //     height: 230, // fixed height
            //     display: "flex",
            //     flexDirection: "column",
            //     justifyContent: "space-between",
            //     borderRadius: "16px", // same as the rest
            //     boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)", // smooth shadow
            //     bgcolor: "#ffffff", // white like cards
            //   }}
            // >
            //   <Box>
            //     <Box
            //       sx={{
            //         display: "flex",
            //         justifyContent: "space-between",
            //         mb: 0.75,
            //         flexDirection: { xs: "column", sm: "row" },
            //         alignItems: { xs: "flex-start", sm: "center" },
            //       }}
            //     >
            //       <Typography
            //         sx={{ fontWeight: 600, color: "#2c3e50", display: "inline-block", fontSize: "0.85rem" }}
            //       >
            //         {message.sender}
            //         <Box
            //           component="span"
            //           sx={{
            //             fontWeight: "normal",
            //             color: "#7f8c8d",
            //             fontSize: "0.8rem",
            //             ml: 0.5,
            //           }}
            //         >
            //           to {message.receiver}
            //         </Box>
            //       </Typography>

            //       <Box
            //         sx={{
            //           display: "flex",
            //           alignItems: "center",
            //           color: "#95a5a6",
            //           fontSize: "0.75rem",
            //           mt: { xs: 0.3, sm: 0 },
            //         }}
            //       >
            //         <FiClock style={{ marginRight: 3, fontSize: 12 }} />
            //         {new Date(message.createdAt).toLocaleString("en-US", {
            //           month: "short",
            //           day: "numeric",
            //           hour: "2-digit",
            //           minute: "2-digit",
            //         })}
            //       </Box>
            //     </Box>

            //     <Typography variant="h6" sx={{ color: "#2c3e50", my: 0.75, fontSize: "1rem" }}>
            //       {message.subject}
            //     </Typography>

            //     <Typography
            //       variant="body2"
            //       sx={{
            //         color: "#7f8c8d",
            //         mb: 1.5,
            //         fontSize: "0.85rem",
            //         lineHeight: 1.3,
            //         height: 60,  // smaller height for preview
            //         overflow: "hidden",
            //         textOverflow: "ellipsis",
            //         display: "-webkit-box",
            //         WebkitLineClamp: 3,  // show max 3 lines
            //         WebkitBoxOrient: "vertical",
            //       }}
            //     >
            //       {message.message}
            //     </Typography>

            //     {message.files && message.files.length > 0 && (
            //       <Box
            //         sx={{
            //           display: "flex",
            //           alignItems: "center",
            //           color: "#3498db",
            //           fontSize: "0.75rem",
            //           mb: 1.5,
            //         }}
            //       >
            //         <FiPaperclip style={{ marginRight: 3 }} />
            //         <Typography component="span" sx={{ fontSize: "0.75rem" }}>
            //           {message.files.length} {message.files.length === 1 ? "attachment" : "attachments"}
            //         </Typography>
            //       </Box>
            //     )}
            //   </Box>

            //   <Box
            //     sx={{
            //       display: "flex",
            //       alignItems: "center",
            //       color: "#3498db",
            //       fontSize: "0.85rem",
            //       fontWeight: 500,
            //       mt: "auto",
            //     }}
            //   >
            //     <Typography component="span" sx={{ fontSize: "0.85rem" }}>
            //       View Details
            //     </Typography>
            //     <FiChevronRight style={{ marginLeft: 4, transition: "transform 0.2s", fontSize: 16 }} />
            //   </Box>

            //   {!message.read && (
            //     <Box
            //       sx={{
            //         position: "absolute",
            //         top: 14,
            //         right: 14,
            //         width: 8,
            //         height: 8,
            //         bgcolor: "#3498db",
            //         borderRadius: "50%",
            //       }}
            //     />
            //   )}
            // </Box>
            /////. new cards/
            <Box
              key={message._id}
              onClick={() => handleReadMore(message)}
              sx={{
                p: { xs: 2, md: 3 },
                cursor: "pointer",
                position: "relative",
                overflow: "hidden",
                transition: "all 0.3s ease",
                borderRadius: "16px",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)",
                height: 170,
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                bgcolor: "#ffffff",
                "&:hover": {
                  bgcolor: "#ffffff",
                  transform: "translateY(-1.5px)",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.18)",
                  "& .default-view": {
                    transform: "translateY(50px)",
                    opacity: 0,
                    transition: "transform 0.4s ease, opacity 0.4s ease"
                  },
                  "& .hover-view": {
                    transform: "translateY(0)",
                    opacity: 1,
                    transition: "transform 0.4s ease, opacity 0.4s ease"
                  },
                  "& .arrow-icon": {
                    transform: "rotate(0deg)",
                    transition: "transform 0.4s ease"
                  }
                }
              }}
            >
              {/* Default View: Sender + Mail Icon + Date */}
              <Box
                className="default-view"
                sx={{
                  width: "100%",
                  zIndex: 1,
                  flex: 1,
                  display: "flex",
                  p: 1,
                  flexDirection: "column",
                  justifyContent: "space-between"
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <FiMail style={{ fontSize: 18, color: "#b30000" }} />
                  <Typography
                    sx={{
                      fontWeight: 700,
                      color: "#1E293B",
                      fontSize: "1.1rem"
                    }}
                  >
                    <Box
                      component="span"
                      sx={{ color: "#b30000", fontWeight: 700 }}
                    >
                      {message.sender}
                    </Box>{" "}
                    to{" "}
                    <Box
                      component="span"
                      sx={{ color: "#b30000", fontWeight: 700 }}
                    >
                      {message.receiver}
                    </Box>
                  </Typography>

                </Box>

                {/* Subject line below */}
                <Typography
                  sx={{
                    color: "#64748B",
                    fontSize: "0.95rem",
                    fontWeight: 500,
                    mt: 0.3
                  }}
                >
                  {message.subject
                    ?.split(" ") // split into words
                    .slice(0, 15) // take first 25 words
                    .join(" ") + (message.subject?.split(" ").length > 15 ? "..." : "")}
                </Typography>


                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "#000000",
                    fontWeight: 600,
                    fontSize: "0.8rem",
                    mt: "auto"
                  }}
                >
                  <FiClock style={{ marginRight: 5, fontSize: 14 }} />
                  {new Date(message.createdAt).toLocaleString("en-US", {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit"
                  })}
                </Box>

                {!message.read && <div className="message-unread-badge"></div>}
              

              </Box>

              {/* Hover View */}
              <Box
                className="hover-view"
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  opacity: 0,
                  transform: "translateY(-30px)",
                  transition: "transform 0.4s ease, opacity 0.4s ease",
                  overflowY: "auto",
                  p: { xs: 2, md: 4 },
                  pb: 6,
                  pr: 1,
                  "&::-webkit-scrollbar": { width: "5px" },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#b0b0b0",
                    borderRadius: "10px"
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: "#999"
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "transparent"
                  }
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    color: "#000000",
                    fontWeight: 400,
                    fontSize: "0.95rem",
                    lineHeight: 1.5,
                    whiteSpace: "pre-wrap"
                  }}
                >
                  {message.message}
                </Typography>
              </Box>

              {/* Arrow Icon */}
              <Box
                className="arrow-icon"
                sx={{
                  position: "absolute",
                  bottom: 16,
                  right: 16,
                  transform: "rotate(45deg)",
                  transition: "transform 0.4s ease"
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="36" // increased from 28
                  height="36" // increased from 28
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#b30000"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </Box>
            </Box>
          ))}
        </Box>


      </Box>

      <MessageModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        message={selectedMessage}
      />

      <Footer />
    </Box>
  );
};

export default MyMessages;
